export const createStory = "post/story";
export const getStories = "get/stories";
export const getMyStories = "get/mystories";
export const getStoryById = "get/StoryById";
export const getCountryData = "get/CountryData";
export const updateStories = "put/uodateStories";
export const deleteStories = "delete/stories";
